module.exports = __webpack_public_path__ + "df6578df707558fe87b9b815910a04f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/etsy_2023_chart.png
// module id = 1672
// module chunks = 0